import { makeAutoObservable } from 'mobx';

export class ErrorStore {
  public error: string = '';
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public setError = (error: string) => {
    this.error = error;
  };
}
